export default __webpack_public_path__ + "static/media/lightlogo.9eab263a.png";